import { SisMapReference } from 'src/app/sismap-reference/domain/sismap-reference.model';

export class SisMapReferenceAdapter {
  static adapt(item: any): SisMapReference {
    if (!item) {
      return null;
    }

    return {
      tenant: item.tenant,
      name: item.name,
      season: item.season,
      logoFilename: item.logoFilename,
      areaUrlName: item.areaUrlName,
      sisId: item.sisId,
      mapType: item.mapType
    };
  }
}
